import { render, staticRenderFns } from "./OrganizationResponsibilitiesTable.vue?vue&type=template&id=3730e050&scoped=true"
import script from "./OrganizationResponsibilitiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationResponsibilitiesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationResponsibilitiesTable.vue?vue&type=style&index=0&id=3730e050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3730e050",
  null
  
)

export default component.exports